var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 24,
    viewBox: "0 0 17 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_368:5562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8654 0H11.899C7.45673 0 4.56923 2.32258 4.56923 5.91884V8.641H0.634615C0.285577 8.641 0 8.86576 0 9.14048V13.0864C0 13.3611 0.285577 13.5858 0.634615 13.5858H4.60096V23.5505C4.60096 23.8252 4.88654 24.0499 5.23558 24.0499H10.4394C10.7885 24.0499 11.074 23.8252 11.074 23.5505V13.5609H15.7385C16.0875 13.5609 16.3731 13.3361 16.3731 13.0614V9.11551C16.3731 8.99063 16.3096 8.86576 16.1827 8.76587C16.0558 8.66597 15.8971 8.61603 15.7385 8.61603H11.0423V6.31842C11.0423 5.21956 11.3913 4.64516 13.2 4.64516H15.8654C16.2144 4.64516 16.5 4.4204 16.5 4.14568V0.49948C16.5 0.224766 16.2144 0 15.8654 0Z",
    fill: "#68717A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_368:5562"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.5,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/FB.1ef489d5.svg";
export { ForwardRef as ReactComponent };